import { IUser } from '~/models';
import AttendanceBadge from '../../components/candidates/AttendanceBadge';
import MultiProfessionalBadges from '../../components/candidates/MultiProfessionalBadges';
import { Box } from '../Box';

interface IProps {
  professional: IUser;
}

/**
 * BadgeList Component
 *
 * Renders professional badges based on the badge system version:
 * - V2: Shows MultiProfessionalBadges when professional.badges exists
 * - Legacy: Shows AttendanceBadge when only professional.currentRank exists
 * - Returns null when neither badges nor rank exist
 *
 * ⚠️  DEVELOPER NOTE: This component is currently located in commonComponents
 * but appears to be used only for professional profiles. Consider whether this
 * should be moved to a more specific location like:
 * - src/components/ProfessionalProfile/components/
 * - src/components/candidates/
 *
 * If this is truly only used for professional profiles, it may not need
 * to be a shared component.
 */
export const BadgeList = ({ professional }: IProps) => {
  const isBadgesV2 = !!professional?.badges?.length;

  if (!isBadgesV2 && !professional?.currentRank?.rank) {
    return null;
  }

  return (
    <Box data-testid="badge-list">
      {isBadgesV2 ? (
        // @ts-expect-error - MultiProfessionalBadges still on Javascript Component
        <MultiProfessionalBadges badges={professional?.badges} />
      ) : (
        // @ts-expect-error - AttendanceBadge still on Javascript Component
        <AttendanceBadge currentRank={professional?.currentRank} />
      )}
    </Box>
  );
};
